import { Component, OnInit } from '@angular/core';
import { Application, Modules } from 'src/app/appCommon/Enums/enum';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  url: string = '';
  applicationName: string = '';
  privacyPolicyUrl: string = '';
  termOfUseUrl: string = '';
  copyRightNoticeUrl: string = '';
  teleUrl: string = environment.teleUrl;
  constructor() {
    this.applicationName = Application.Name;
    this.url = Modules.Layout;
    this.privacyPolicyUrl = Modules.StaticPages + '/' + Modules.PrivacyPolicy;
    this.termOfUseUrl = Modules.StaticPages + '/' + Modules.TermsOfUse;
    this.copyRightNoticeUrl = Modules.StaticPages + '/' + Modules.CopyrightNotice;
   }

  ngOnInit(): void {
  }
  getYear(){
    return (new Date()).getFullYear();
  }
}
